import React from 'react';
import { View } from 'react-native';
import { isSameDay } from 'date-fns';
import { useLocalization } from '@sendbird/uikit-react-native';
import { Text } from '@shared/components/text';
import type { TChatDaySeparatorProps } from '../../types';

export const ChatDaySeparator = ({ message, prevMessage }: TChatDaySeparatorProps) => {
    const { STRINGS } = useLocalization();
    if (isSameDay(message.createdAt, prevMessage?.createdAt ?? 0)) return null;

    return (
        <View className="flex-row items-center gap-3 px-md mt-2 mb-4">
            <View className="flex-1 h-px bg-gray-300" />
            <Text className="text-sm text-gray-500">
                {STRINGS.GROUP_CHANNEL.LIST_DATE_SEPARATOR(new Date(message.createdAt))}
            </Text>
            <View className="flex-1 h-px bg-gray-300" />
        </View>
    );
};
